import React from 'react';
import {Outlet, useLocation, useNavigate, useParams} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {useGetEmployeeByIdQuery} from '../../../api/services/employeeService';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const tabs = [
    {label: 'Basic', path: ''},
    {label: 'Forms', path: 'forms'},
];

export const EmployeeProfileDetails = () => {
    const {id} = useParams();
    const {data = {}, isLoading} = useGetEmployeeByIdQuery(id);
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const activePath = pathname.includes('/forms') ? 'forms' : '';

    const navigateBack = () => navigate('/profiles');

    return (
        <Stack
            gap={2}
            marginTop={1}
            flexGrow={1}
        >
            <Stack>
                <Box marginBottom={1}>
                    <Button
                        variant="text"
                        startIcon={<ArrowBackRoundedIcon/>}
                        onClick={navigateBack}
                    >
                        Back
                    </Button>
                </Box>
                {
                    Object.keys(data).length
                        ? <Typography variant="h4">
                            Personal Details for {`${data.legalForename} ${data.legalSurname}`}
                        </Typography>
                        : null
                }
                <Tabs
                    value={activePath}
                    onChange={(_, newPath) => navigate(newPath)}
                >
                    {tabs.map(tab => (
                        <Tab
                            key={tab.path}
                            label={tab.label}
                            value={tab.path}/>
                    ))}
                </Tabs>
            </Stack>
            <Outlet context={{data, isLoading}}/>
        </Stack>
    );
};

export default EmployeeProfileDetails;